module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-chevy.b7751f99.png";